export const environment = {
  nombre: "QA de PEREYRA",
  logo: "assets/Logo/Pereyra/",
  production: true,
  url: "aHR0cHM6Ly93ZWJwZXJleXJhLmNvbS5teC9RQS9FdmFsdWFjaW9uMzYwX1NlcnZpY2UvcHVibGljL2FwaS8="
};
